export const DiccionarioAcademico_ES = [
    {
        'codigo': 'CodeRequeridoBuildingFloorId',
        'mensaje': 'El piso es requerido.'
    },
    {
        'codigo': 'CodeRequeridoCampusId',
        'mensaje': 'La sede es requerida.'
    },
    {
        'codigo': 'CodeRequeridoProgramId',
        'mensaje': 'El programa es requerido.'
    },
    {
        'codigo': 'CodeRequeridoCapacity',
        'mensaje': 'La capacidad es requerida.'
    },
    {
        'codigo': 'CodeRequeridoBuildingId',
        'mensaje': 'El edificio es requerido.'
    },
    {
        'codigo': 'CodeRequeridoClassroomTypeId',
        'mensaje': 'El tipo de aula es requerido.'
    },
    {
        'codigo': 'CodeRequeridoCourseId',
        'mensaje': 'El curso es requerido.'
    },
    {
        'codigo': 'CodeRequeridoFechaAprovado',
        'mensaje': 'La fecha de aprobación es requerida.'
    },
    {
        'codigo': 'CodeRequeridoPeriodDetailId',
        'mensaje': 'Debe seleccionar un detalle del periodo académico.'
    },
    {
        'codigo': 'CodeRequeridoPeriodId',
        'mensaje': 'El periodo académico es requerido.'
    },
    {
        'codigo': 'CodeRequeridoWeekdays',
        'mensaje': 'El día es requerido.'
    },
    {
        'codigo': 'ErrorCompararFecha',
        'mensaje': 'La fecha de inicio no debe ser mayor a la fecha de final.'
    },
    {
        'codigo': 'ErrorCrearUnEvento',
        'mensaje': 'Al menos debe crear un horario para continuar.'
    },
    {
        'codigo': 'ErrorSelecUnPrograma',
        'mensaje': 'Al menos un seleccionar un curso y programa académico.'
    },
    {
        'codigo': 'ErrorTipoCIFNotEmty',
        'mensaje': 'Debe seleccionar un tipo de CIF.'
    },
    {
        'codigo': 'ErrorValidDateFormat',
        'mensaje': 'Debe ingresar una fecha válida.'
    },
    {
        'codigo': 'warningSedePrograma',
        'mensaje': 'No se encontró la sede de la admisión, verifique los permisos del usuario y las sedes del programa académico.'
    },
    {
        'codigo': 'WarningSelectBlock',
        'mensaje': 'Debe seleccionar un bloque para el requisito de admisión.'
    },
    {
        'codigo': 'WarningSelectCalificacion',
        'mensaje': 'Debe seleccionar una clasificación.'
    },
    {
        'codigo': 'WarningSelectCareerCode',
        'mensaje': 'El código de la carrera es requerido.'
    },
    {
        'codigo': 'WarningSelectCarrera',
        'mensaje': 'La carrera es requerida.'
    },
    {
        'codigo': 'WarningSelectCourse',
        'mensaje': 'El curso es requerido.'
    },
    {
        'codigo': 'WarningSelectEstudiante',
        'mensaje': 'Debe seleccionar un estudiante.'
    },
    {
        'codigo': 'WarningSelectGradeCode',
        'mensaje': 'Debe seleccionar un grado académico.'
    },
    {
        'codigo': 'WarningSelectGrado',
        'mensaje': 'Debe seleccionar un grado académico.'
    },
    {
        'codigo': 'WarningSelectJornada',
        'mensaje': 'Debe seleccionar una jornada.'
    },
    {
        'codigo': 'WarningSelectModalidad',
        'mensaje': 'Debe seleccionar una modalidad.'
    },
    {
        'codigo': 'WarningSelectPais',
        'mensaje': 'Debe seleccionar un país.'
    },
    {
        'codigo': 'WarningSelectPrograma',
        'mensaje': 'Debe seleccionar un programa académico.'
    },
    {
        'codigo': 'WarningSelectRequirement',
        'mensaje': 'Debe seleccionar un requisito.'
    },
    {
        'codigo': 'WarningSelectSede',
        'mensaje': 'Debe seleccionar una sede.'
    },
    {
        'codigo': 'WarningSelectTipoOferta',
        'mensaje': 'Debe seleccionar el tipo de oferta académica.'
    },
    {
        'codigo': 'WarningSelectTipoPeriodo',
        'mensaje': 'Debe seleccionar el tipo de periodo.'
    },
    {
        'codigo': 'WarningSubPeriod',
        'mensaje': 'Debe ingresar el número de subperiodo.'
    },
    {
        'codigo': 'ErrorActualizarAdmisionSede',
        'mensaje': 'Se presentaron problemas al actualizar las sede de la admisión.'
    },
    {
        'codigo': 'ErrorActualizarAsistencia',
        'mensaje': 'Se presentaron problemas al actualizar la asistencia de estudiantes.'
    },
    {
        'codigo': 'ErrorActualizarInstructor',
        'mensaje': 'Se presentaron problemas al actualizar el instructor.'
    },
    {
        'codigo': 'ErrorActualizarSedesDetalle',
        'mensaje': 'Se presentaron problemas al actualizar las sedes.'
    },
    {
        'codigo': 'ErrorAnnotationIdNotEmpty',
        'mensaje': 'No se encontraron los datos de la anotación.'
    },
    {
        'codigo': 'ErrorAnnotationNotEmpty',
        'mensaje': 'Debe ingresar una anotación.'
    },
    {
        'codigo': 'ErrorAnnotationTypeIdNotEmpty',
        'mensaje': 'Debe seleccionar el tipo de anotación.'
    },
    {
        'codigo': 'ErrorCommentNotEmpty',
        'mensaje': 'Debe ingresar un comentario.'
    },
    {
        'codigo': 'ErrorCreateRequisitoAdminision',
        'mensaje': 'Se presentaron problemas al crear el requisito de admisión.'
    },
    {
        'codigo': 'ErrorCreateRequisitoGraduacion',
        'mensaje': 'Se presentaron problemas al crear el requisito de graduación.'
    },
    {
        'codigo': 'ErrorDeleteAcaProgram',
        'mensaje': 'Se presentaron problemas al eliminar el programa académico.'
    },
    {
        'codigo': 'ErrorDeleteAcaProgramDetails',
        'mensaje': 'Se presentaron problemas al eliminar el detalle del programa académico.'
    },
    {
        'codigo': 'ErrorDeleteAdmission',
        'mensaje': 'Se presentaron problemas al eliminar la admisión.'
    },
    {
        'codigo': 'ErrorDeleteAnnotation',
        'mensaje': 'Se presentaron problemas al eliminar la anotación.'
    },
    {
        'codigo': 'ErrorDeleteAttachRequirements',
        'mensaje': 'Se presentaron problemas al eliminar el documento adjunto.'
    },
    {
        'codigo': 'ErrorDeleteAula',
        'mensaje': 'Se presentaron problemas al eliminar el aula.'
    },
    {
        'codigo': 'ErrorDeleteCareer',
        'mensaje': 'Se presentaron problemas al eliminar la carrera.'
    },
    {
        'codigo': 'ErrorDeleteClient',
        'mensaje': 'Se presentaron problemas al eliminar el CIF.'
    },
    {
        'codigo': 'ErrorDeleteClientContries',
        'mensaje': 'Se presentaron problemas al eliminar la nacionalidad.'
    },
    {
        'codigo': 'ErrorDeleteClientWorkplace',
        'mensaje': 'Se presentaron problemas al eliminar la información laboral.'
    },
    {
        'codigo': 'ErrorDeleteCourse',
        'mensaje': 'Se presentaron problemas al eliminar el curso.'
    },
    {
        'codigo': 'ErrorDeleteCurriculumCourse',
        'mensaje': 'Se presentaron problemas al eliminar el currículum.'
    },
    {
        'codigo': 'ErrorDeleteCustomerAddress',
        'mensaje': 'Se presentaron problemas al eliminar la dirección.'
    },
    {
        'codigo': 'ErrorDeleteCustomerContacts',
        'mensaje': 'Se presentaron problemas al eliminar el contacto.'
    },
    {
        'codigo': 'ErrorDeleteCustomerEmail',
        'mensaje': 'Se presentaron problemas al eliminar el correo electrónico.'
    },
    {
        'codigo': 'ErrorDeleteCustomerLanguaje',
        'mensaje': 'Se presentaron problemas al eliminar el idioma.'
    },
    {
        'codigo': 'ErrorDeleteCustomerProfiles',
        'mensaje': 'Se presentaron problemas al eliminar el tipo de CIF.'
    },
    {
        'codigo': 'ErrorDeleteFileAnnotation',
        'mensaje': 'Se presentaron problemas al eliminar el archivo adjunto.'
    },
    {
        'codigo': 'ErrorDeleteHorario',
        'mensaje': 'Se presentaron problemas al eliminar el horario.'
    },
    {
        'codigo': 'ErrorDeleteInstructor',
        'mensaje': 'Se presentaron problemas al eliminar el instructor.'
    },
    {
        'codigo': 'ErrorDeleteOfertaAcademica',
        'mensaje': 'Se presentaron problemas al eliminar la oferta académica.'
    },
    {
        'codigo': 'ErrorDeletePeriodoDetalle',
        'mensaje': 'Se presentaron problemas al eliminar el detalle del periodo académico.'
    },
    {
        'codigo': 'ErrorDeletePeriodosAca',
        'mensaje': 'Se presentaron problemas al eliminar el periodo académico.'
    },
    {
        'codigo': 'ErrorDeleteProgramCourseGrouping',
        'mensaje': 'Se presentaron problemas al eliminar el curso.'
    },
    {
        'codigo': 'ErrorDeleteRequisitoAdminision',
        'mensaje': 'Se presentaron problemas al eliminar el requisito de admisión.'
    },
    {
        'codigo': 'ErrorDeleteRequisitoCurso',
        'mensaje': 'Se presentaron problemas al eliminar el requisito del curso.'
    },
    {
        'codigo': 'ErrorDeleteRequisitoGraduacion',
        'mensaje': 'Se presentaron problemas al eliminar el requisito de graduación.'
    },
    {
        'codigo': 'ErrorEnrollChangeAcaOffer',
        'mensaje': 'Se presentaron problemas al realizar el cambio de curso.'
    },
    {
        'codigo': 'ErrorEstudiantesAsistencia',
        'mensaje': 'Se presentaron problemas al obtener la asistencia de estudiantes.'
    },
    {
        'codigo': 'ErrorFavoriteCustomerAddress',
        'mensaje': 'Se presentaron problemas al obtener las direcciones.'
    },
    {
        'codigo': 'ErrorFavoriteCustomerContacts',
        'mensaje': 'Se presentaron problemas al obtener los contactos.'
    },
    {
        'codigo': 'ErrorGetAcaProgram',
        'mensaje': 'Se presentaron problemas al obtener el detalle del programa.'
    },
    {
        'codigo': 'ErrorGetAdmission',
        'mensaje': 'Se presentaron problemas al obtener el detalle de la admisión.'
    },
    {
        'codigo': 'ErrorGetAula',
        'mensaje': 'Se presentaron problemas al obtener el detalle del aula.'
    },
    {
        'codigo': 'ErrorGetCareer',
        'mensaje': 'Se presentaron problemas al obtener el detalle de la carrera.'
    },
    {
        'codigo': 'ErrorGetClientContries',
        'mensaje': 'Se presentaron problemas al obtener los países.'
    },
    {
        'codigo': 'ErrorGetCourse',
        'mensaje': 'Se presentaron problemas al obtener el detalle del curso.'
    },
    {
        'codigo': 'ErrorGetJornadaProgramAca',
        'mensaje': 'Se presentaron problemas al obtener el detalle de la jornada.'
    },
    {
        'codigo': 'ErrorGetListAttachRequirements',
        'mensaje': 'Se presentaron problemas al obtener la lista de adjuntos de los requisitos.'
    },
    {
        'codigo': 'ErrorGetListClientWorkplace',
        'mensaje': 'Se presentaron problemas al obtener la información laboral.'
    },
    {
        'codigo': 'ErrorGetOfertaAcademica',
        'mensaje': 'Se presentaron problemas al obtener el detalle de la oferta académica.'
    },
    {
        'codigo': 'ErrorGetPeriodosAca',
        'mensaje': 'Se presentaron problemas al obtener los periodos académicos.'
    },
    {
        'codigo': 'ErrorGetProgramBlocks',
        'mensaje': 'Se presentaron problemas al obtener los bloques del programa académico.'
    },
    {
        'codigo': 'ErrorGetStudentAcaOffer',
        'mensaje': 'Se presentaron problemas al obtener los estudiantes inscritos.'
    },
    {
        'codigo': 'ErrorInsertAnnotation',
        'mensaje': 'Se presentaron problemas al registrar la anotación.'
    },
    {
        'codigo': 'ErrorInsertAttachRequirements',
        'mensaje': 'Se presentaron problemas cargar el documento adjunto.'
    },
    {
        'codigo': 'ErrorInsertFileAnnotation',
        'mensaje': 'Se presentaron problemas cargar el documento adjunto.'
    },
    {
        'codigo': 'ErrorInsertRequisitoCurso',
        'mensaje': 'Se presentaron problemas registrar el requisito del curso.'
    },
    {
        'codigo': 'ErrorInstructorIdNotEmty',
        'mensaje': 'No se encontró la información del instructor.'
    },
    {
        'codigo': 'ErrorLessonDateNotEmpty',
        'mensaje': 'Debe indicar la fecha de la lección.'
    },
    {
        'codigo': 'ErrorListAcaAula',
        'mensaje': 'Se presentaron problemas al obtener la lista de aulas.'
    },
    {
        'codigo': 'ErrorListAcaProgramDetails',
        'mensaje': 'Se presentaron problemas al obtener el detalle del programa académico.'
    },
    {
        'codigo': 'ErrorListAcaRecursos',
        'mensaje': 'Se presentaron problemas al obtener la lista de recursos.'
    },
    {
        'codigo': 'ErrorListAdmisionSede',
        'mensaje': 'Se presentaron problemas al obtener la lista de sedes para la admisión.'
    },
    {
        'codigo': 'ErrorListaEstudiantesOfertaAcademica',
        'mensaje': 'Se presentaron problemas al obtener los estudiantes inscritos.'
    },
    {
        'codigo': 'ErrorListAnnotation',
        'mensaje': 'Se presentaron problemas al obtener la lista de anotaciones.'
    },
    {
        'codigo': 'ErrorListaRubrosCalificacion',
        'mensaje': 'Se presentaron problemas al obtener la lista de rubros de calificación.'
    },
    {
        'codigo': 'ErrorListAulas',
        'mensaje': 'Se presentaron problemas al obtener la lista de aulas.'
    },
    {
        'codigo': 'ErrorListAulasDisponibles',
        'mensaje': 'Se presentaron problemas al obtener la lista de aulas disponibles.'
    },
    {
        'codigo': 'ErrorListAulasSugeridas',
        'mensaje': 'Se presentaron problemas al obtener la lista de aulas sugeridas.'
    },
    {
        'codigo': 'ErrorListCorrequisitosCursos',
        'mensaje': 'Se presentaron problemas al obtener la lista de cursos corequisitos.'
    },
    {
        'codigo': 'ErrorListCurriculumCourse',
        'mensaje': 'Se presentaron problemas al obtener la lista de cursos curriculares.'
    },
    {
        'codigo': 'ErrorListCursosEstudiantes',
        'mensaje': 'No se pudo obtener el listado de cursos del estudiante.'
    },
    {
        'codigo': 'ErrorListCursosHorarios',
        'mensaje': 'Se presentaron problemas al obtener el listado de horarios de los cursos de la oferta acádemica.'
    },
    {
        'codigo': 'ErrorListCursosOfertaAcademica',
        'mensaje': 'Se presentaron problemas al obtener el listado de cursos de la oferta acádemica.'
    },
    {
        'codigo': 'ErrorListCursosOfertados',
        'mensaje': 'Se presentaron problemas al obtener el listado de cursos ofertados.'
    },
    {
        'codigo': 'ErrorListCursosRecurso',
        'mensaje': 'Se presentaron problemas al obtener los recursos del curso.'
    },
    {
        'codigo': 'ErrorListCustomerAddress',
        'mensaje': 'Se presentaron problemas al obtener las direcciones.'
    },
    {
        'codigo': 'ErrorListCustomerContacts',
        'mensaje': 'Se presentaron problemas al obtener los contactos.'
    },
    {
        'codigo': 'ErrorListCustomerEmail',
        'mensaje': 'Se presentaron problemas al obtener los correos electrónicos.'
    },
    {
        'codigo': 'ErrorListCustomerLanguaje',
        'mensaje': 'Se presentaron problemas al obtener los idiomas.'
    },
    {
        'codigo': 'ErrorListCustomerProfiles',
        'mensaje': 'Se presentaron problemas al obtener los tipos de CIF.'
    },
    {
        'codigo': 'ErrorListDetalleJornada',
        'mensaje': 'Se presentaron problemas al obtener el detalle de la jornada.'
    },
    {
        'codigo': 'ErrorListDetalles',
        'mensaje': 'Se presentaron problemas al obtener la lista de detalles.'
    },
    {
        'codigo': 'ErrorListFormatFile',
        'mensaje': 'Se presentaron problemas al obtener la lista de formatos de archivos.'
    },
    {
        'codigo': 'ErrorListGruposOfertados',
        'mensaje': 'Se presentaron problemas al obtener la lista de grupos ofertados.'
    },
    {
        'codigo': 'ErrorListHorarios',
        'mensaje': 'Se presentaron problemas al obtener la lista de horarios.'
    },
    {
        'codigo': 'ErrorListInstructoresAsignado',
        'mensaje': 'Se presentaron problemas al obtener los instructores asignados.'
    },
    {
        'codigo': 'ErrorListInstructoresDisponibles',
        'mensaje': 'Se presentaron problemas al obtener los instructores disponibles.'
    },
    {
        'codigo': 'ErrorListInstructoresSugeridos',
        'mensaje': 'Se presentaron problemas al obtener los instructores sugeridos.'
    },
    {
        'codigo': 'ErrorListOfertaAcademica',
        'mensaje': 'Se presentaron problemas al obtener las ofertas académicas.'
    },
    {
        'codigo': 'ErrorListOfertaAcademicaPractica',
        'mensaje': 'Se presentaron problemas al obtener las ofertas académicas disponibles para prácticas/laborarios.'
    },
    {
        'codigo': 'ErrorListProgramaCursosRecurso',
        'mensaje': 'Se presentaron problemas al obtener el listado de recursos del programa por curso.'
    },
    {
        'codigo': 'ErrorListProgramCourseGrouping',
        'mensaje': 'Se presentaron problemas al obtener el listado de agrupaciones del curso del programa.'
    },
    {
        'codigo': 'ErrorListProgramCourseGroupingRequirement',
        'mensaje': 'Se presentaron problemas al obtener el listado de requisitos de la agrupaciones del curso del programa.'
    },
    {
        'codigo': 'ErrorListRequisitoAdminision',
        'mensaje': 'Se presentaron problemas al obtener el listado de requisitos de admisión del programa.'
    },
    {
        'codigo': 'ErrorListRequisitoCurso',
        'mensaje': 'Se presentaron problemas al obtener el listado de requisitos del curso.'
    },
    {
        'codigo': 'ErrorListRequisitoCursoVin',
        'mensaje': 'Se presentaron problemas al obtener el listado curso vinculados al programa.'
    },
    {
        'codigo': 'ErrorListRequisitosCursos',
        'mensaje': 'Se presentaron problemas al obtener el listado de requisitos del curso.'
    },
    {
        'codigo': 'ErrorListSedesDetalles',
        'mensaje': 'No se pudo obtener la lista de sedes.'
    },
    {
        'codigo': 'ErrorListSedesPrograma',
        'mensaje': 'Se presentaron problemas al obtener el listado de sedes del programa.'
    },
    {
        'codigo': 'ErrorListSedesVinculadasPrograma',
        'mensaje': 'Se presentaron problemas al obtener el listado de sedes vinculadas del programa.'
    },
    {
        'codigo': 'ErrorListSemanasOfertaAcademica',
        'mensaje': 'Se presentaron problemas al obtener las semanas de la oferta académica.'
    },
    {
        'codigo': 'ErrorRequisitoAdminisionByID',
        'mensaje': 'Se presentaron problemas al obtener los requisitos de admisión.'
    },
    {
        'codigo': 'ErrorRetirarCursoEst',
        'mensaje': 'Se presentaron problemas al realizar el proceso de retiro del curso.'
    },
    {
        'codigo': 'ErrorSaveAcaProgram',
        'mensaje': 'Se presentaron problemas al guardar la información del programa académico.'
    },
    {
        'codigo': 'ErrorSaveAula',
        'mensaje': 'Se presentaron problemas al guardar la información del aula.'
    },
    {
        'codigo': 'ErrorSaveCareer',
        'mensaje': 'Se presentaron problemas al guardar la información de la carrera.'
    },
    {
        'codigo': 'ErrorSaveClient',
        'mensaje': 'Se presentaron problemas al guardar la información del CIF.'
    },
    {
        'codigo': 'ErrorSaveClientContries',
        'mensaje': 'Se presentaron problemas al guardar la información de la nacionalidad.'
    },
    {
        'codigo': 'ErrorSaveClientWorkplace',
        'mensaje': 'Se presentaron problemas al guardar la información de la información laboral.'
    },
    {
        'codigo': 'ErrorSaveCourse',
        'mensaje': 'Se presentaron problemas al guardar la información del curso.'
    },
    {
        'codigo': 'ErrorSaveCurriculumCourse',
        'mensaje': 'Se presentaron problemas al guardar la información del currículum.'
    },
    {
        'codigo': 'ErrorSaveCustomerAddress',
        'mensaje': 'Se presentaron problemas al guardar la información de la dirección.'
    },
    {
        'codigo': 'ErrorSaveCustomerContacts',
        'mensaje': 'Se presentaron problemas al guardar la información del contacto.'
    },
    {
        'codigo': 'ErrorSaveCustomerEmail',
        'mensaje': 'Se presentaron problemas al guardar la información del correo electrónico.'
    },
    {
        'codigo': 'ErrorSaveCustomerLanguaje',
        'mensaje': 'Se presentaron problemas al guardar la información del idioma.'
    },
    {
        'codigo': 'ErrorSaveCustomerProfiles',
        'mensaje': 'Se presentaron problemas al guardar la información del tipo de CIF'
    },
    {
        'codigo': 'ErrorSaveHorario',
        'mensaje': 'Se presentaron problemas al guardar la información del horario'
    },
    {
        'codigo': 'ErrorSaveInstructor',
        'mensaje': 'Se presentaron problemas al guardar la información del instructor'
    },
    {
        'codigo': 'ErrorSaveOfertaAcademica',
        'mensaje': 'Se presentaron problemas al guardar la información de la oferta académica'
    },
    {
        'codigo': 'ErrorSavePeriodoDetalle',
        'mensaje': 'Se presentaron problemas al guardar la información del detalle del periodo académico'
    },
    {
        'codigo': 'ErrorSavePeriodosAca',
        'mensaje': 'Se presentaron problemas al guardar la información del periodo académico'
    },
    {
        'codigo': 'ErrorUpdateAcaProgram',
        'mensaje': 'Se presentaron problemas al guardar la información del programa académico'
    },
    {
        'codigo': 'ErrorUpdateAcaProgramDetails',
        'mensaje': 'Se presentaron problemas al guardar la información del curso del programa académico'
    },
    {
        'codigo': 'ErrorUpdateAdmission',
        'mensaje': 'Se presentaron problemas al guardar la información de la admisión'
    },
    {
        'codigo': 'ErrorUpdateAnnotation',
        'mensaje': 'Se presentaron problemas al guardar la información de la anotación'
    },
    {
        'codigo': 'ErrorUpdateAula',
        'mensaje': 'Se presentaron problemas al guardar la información del aula'
    },
    {
        'codigo': 'ErrorUpdateCareer',
        'mensaje': 'Se presentaron problemas al guardar la información de la carrera'
    },
    {
        'codigo': 'ErrorUpdateClient',
        'mensaje': 'Se presentaron problemas al guardar la información del CIF'
    },
    {
        'codigo': 'ErrorUpdateClientWorkplace',
        'mensaje': 'Se presentaron problemas al guardar la información del lugar de trabajo'
    },
    {
        'codigo': 'ErrorUpdateCourse',
        'mensaje': 'Se presentaron problemas al guardar la información del curso'
    },
    {
        'codigo': 'ErrorUpdateCurriculumCourse',
        'mensaje': 'Se presentaron problemas al guardar la información del currículum'
    },
    {
        'codigo': 'ErrorUpdateCursosOfertaAcademica',
        'mensaje': 'Se presentaron problemas al guardar el curso de la oferta académica'
    },
    {
        'codigo': 'ErrorUpdateCursosRecursos',
        'mensaje': 'Se presentaron problemas al guardar los recursos del curso'
    },
    {
        'codigo': 'ErrorUpdateCustomerAddress',
        'mensaje': 'Se presentaron problemas al guardar la información de la dirección'
    },
    {
        'codigo': 'ErrorUpdateCustomerContacts',
        'mensaje': 'Se presentaron problemas al guardar la información del contacto'
    },
    {
        'codigo': 'ErrorUpdateCustomerEmail',
        'mensaje': 'Se presentaron problemas al guardar la información del correo electrónico'
    },
    {
        'codigo': 'ErrorUpdateCustomerLanguaje',
        'mensaje': 'Se presentaron problemas al guardar la información del idioma'
    },
    {
        'codigo': 'ErrorUpdateDetailsCustomerLanguaje',
        'mensaje': 'Se presentaron problemas al guardar la información del detalle del idioma'
    },
    {
        'codigo': 'ErrorUpdateDetalleJornada',
        'mensaje': 'Se presentaron problemas al guardar la información del detalle de la jornada'
    },
    {
        'codigo': 'ErrorUpdateFormatFile',
        'mensaje': 'Se presentaron problemas al guardar la información de los formatos de archivos'
    },
    {
        'codigo': 'ErrorUpdateHorario',
        'mensaje': 'Se presentaron problemas al guardar la información del horario'
    },
    {
        'codigo': 'ErrorUpdateOfertaAcademica',
        'mensaje': 'Se presentaron problemas al guardar la información de la oferta académica'
    },
    {
        'codigo': 'ErrorUpdatePeriodoDetalle',
        'mensaje': 'Se presentaron problemas al guardar la información del detalle del periodo académico'
    },
    {
        'codigo': 'ErrorUpdatePeriodosAca',
        'mensaje': 'Se presentaron problemas al guardar la información del periodo académico'
    },
    {
        'codigo': 'ErrorUpdateProgramaCursosRecursos',
        'mensaje': 'Se presentaron problemas al guardar la información del curso del programa'
    },
    {
        'codigo': 'ErrorUpdateProgramCourseGrouping',
        'mensaje': 'Se presentaron problemas al guardar la información del curso del programa'
    },
    {
        'codigo': 'ErrorUpdateProgramCourseGroupingRequirement',
        'mensaje': 'Se presentaron problemas al guardar la información de los requisitos del curso'
    },
    {
        'codigo': 'ErrorUpdateRecursos',
        'mensaje': 'Se presentaron problemas al guardar la información de los recursos'
    },
    {
        'codigo': 'ErrorUpdateRequisitoAdminision',
        'mensaje': 'Se presentaron problemas al guardar la información del requisito de admisión'
    },
    {
        'codigo': 'ErrorUpdateRequisitoCurso',
        'mensaje': 'Se presentaron problemas al guardar la información del requisito del curso'
    },
    {
        'codigo': 'ErrorUpdateRequisitoGraduacion',
        'mensaje': 'Se presentaron problemas al guardar la información del requisito de graduación'
    },
    {
        'codigo': 'ErrorUpdateSedes',
        'mensaje': 'Se presentaron problemas al guardar la información de la sede'
    },
    {
        'codigo': 'ErrorUpdateSedesPrograma',
        'mensaje': 'Se presentaron problemas al guardar la información de las sedes del programa'
    },
    {
        'codigo': 'ErrorValidarSedesDetalle',
        'mensaje': 'La sede ya se encuentra vinculada a otro detalle del mismo periodo'
    },
    {
        'codigo': 'ErrorValidatingAcaProgram',
        'mensaje': 'Se presentaron problemas al validar el programa académico'
    },
    {
        'codigo': 'ErrorValidatingAdmission',
        'mensaje': 'El estudiante ya tiene una admisión para este programa académico'
    },
    {
        'codigo': 'ErrorValidatingAula',
        'mensaje': 'Ya existe otra aula con el mismo código'
    },
    {
        'codigo': 'ErrorValidatingAulas',
        'mensaje': 'El aula ya se encuentra asignada al horario'
    },
    {
        'codigo': 'ErrorValidatingCareer',
        'mensaje': 'Se presentaron problemas al validar los datos de la carrera'
    },
    {
        'codigo': 'ErrorValidatingCountryClient',
        'mensaje': 'No se ha podido validar la información del país'
    },
    {
        'codigo': 'ErrorValidatingCourse',
        'mensaje': 'Se presentaron problemas al validar los datos del curso'
    },
    {
        'codigo': 'ErrorValidatingCursosOfertaAcademica',
        'mensaje': 'Se presentaron problemas al validar el curso de la oferta acádemica'
    },
    {
        'codigo': 'ErrorValidatingCustomerEmail',
        'mensaje': 'Se presentaron problemas al validar el correo electrónico'
    },
    {
        'codigo': 'ErrorValidatingCustomerLanguaje',
        'mensaje': 'Se presentaron problemas al validar el idioma'
    },
    {
        'codigo': 'ErrorValidatingFechasCambiarCurso',
        'mensaje': 'Se presentaron problemas al validar las fechas para cambios de cursos'
    },
    {
        'codigo': 'ErrorValidatingFechasInscripcion',
        'mensaje': 'Se presentaron problemas al validar las fechas de inscripción de cursos'
    },
    {
        'codigo': 'ErrorValidatingFechasRetirarCurso',
        'mensaje': 'Se presentaron problemas al validar las fechas para retiro de cursos'
    },
    {
        'codigo': 'ErrorValidatingHorarios',
        'mensaje': 'Se presentaron problemas al validar el horario académico'
    },
    {
        'codigo': 'ErrorChoqueHorariosOft',
        'mensaje': 'No se puede procesar el registro porque hay choques de horarios'
    },
    {
        'codigo': 'ErrorRangoHorariosOft',
        'mensaje': 'No se puede procesar el registro porque el horario está fuera del rango de la jornada'
    },
    {
        'codigo': 'ErrorValidatingInstructor',
        'mensaje': 'Se presentaron problemas al validar el instructor asociado a la oferta acádemica'
    },
    {
        'codigo': 'ErrorGrupoOfertaAcademica',
        'mensaje': 'El número de grupo ingresado ya existe para otra oferta académica'
    },
    {
        'codigo': 'ErrorSchedulesOfertaAcademica',
        'mensaje': 'No se puede cambiar la jornada porque los horarios de la oferta tienen diferentes horas o días de la semana'
    },
    {
        'codigo': 'ErrorValidatingPeriodosAca',
        'mensaje': 'Se presentaron problemas al validar el período académico'
    },
    {
        'codigo': 'ErrorValidatingProgramCourseGrouping',
        'mensaje': 'Se presentaron problemas al validar la agrupación del curso del programa académico'
    },
    {
        'codigo': 'ErrorValidatingProgramDetails',
        'mensaje': 'Se presentaron problemas al validar los detalles del programa académico'
    },
    {
        'codigo': 'ErrorValidatingRequisitoAdminision',
        'mensaje': 'Se presentaron problemas al validar el requisito de admisión del programa'
    },
    {
        'codigo': 'ErrorValidatingRequisitoCurso',
        'mensaje': 'Se presentaron problemas al validar el requisito del curso del programa'
    },
    {
        'codigo': 'ErrorVisualizationNotEmpty',
        'mensaje': 'Debe indicar el tipo de visualización de la anotación del estudiante'
    },
    {
        'codigo': 'ErrorExistsCustomerEmail',
        'mensaje': 'El correo electrónico ya se encuentra registrado'
    },
    {
        'codigo': 'DuplicateCustomerEmail',
        'mensaje': 'El correo electrónico ya se encuentra vinculado a otro CIF'
    },
    {
        'codigo': 'ErrorAcaPeriodDuplicate',
        'mensaje': 'El periodo académico ingresado ya existe'
    },
    {
        'codigo': 'ErrorAcaSubPeriodDuplicate',
        'mensaje': 'El subperiodo académico ingresado ya existe'
    },
    {
        'codigo': 'ErrorCourseAlreadyApp',
        'mensaje': 'El curso seleccionado ya se encuentra aprobado'
    },
    {
        'codigo': 'ErrorCourseAlreadyEnroll',
        'mensaje': 'El curso seleccionado ya se encuentra inscrito'
    },
    {
        'codigo': 'ErrorCourseRequirements',
        'mensaje': 'El curso seleccionado tiene requisitos pendientes'
    },
    {
        'codigo': 'ErrorCustomerUniqueProfile',
        'mensaje': 'No se puede eliminar el registro, debe tener al menos un tipo de CIF'
    },
    {
        'codigo': 'ErrorProgramAcaBlock',
        'mensaje': 'El bloque debe ser consecutivo'
    },
    {
        'codigo': 'ErrorProgramAcaBlock0',
        'mensaje': 'El bloque no debe ser 0'
    },
    {
        'codigo': 'ErrorProgramAcaCurseAliasDupl',
        'mensaje': 'Ya existe ese alias para un curso del programa académico'
    },
    {
        'codigo': 'ErrorProgramAcaCurseDuplicate',
        'mensaje': 'El curso ya existe en el programa académico'
    },
    {
        'codigo': 'ErrorProgramAcaSeqDuplicate',
        'mensaje': 'Ya existe esa secuencia para un curso del programa académico'
    },
    {
        'codigo': 'ErrorProgramAcaSequence',
        'mensaje': 'La secuencia debe ser consecutiva'
    },
    {
        'codigo': 'ErrorProgramAcaSequence0',
        'mensaje': 'La secuencia no debe ser 0'
    },
    {
        'codigo': 'ErrorScheduleConflict',
        'mensaje': 'Se presentaron choques de horarios, verifique la información'
    },
    {
        'codigo': 'InstructorNotAvailable',
        'mensaje': 'El instructor ya no se encuentra disponible para el horario seleccionado'
    },
    {
        'codigo': 'InstructorPrincipal',
        'mensaje': 'Solo puede haber un instructor principal por horario, verifique la información'
    },
    {
        'codigo': 'PeriodDateNotAvailable',
        'mensaje': 'No hay fechas de disponibles del periodo académico para la sede'
    },
    {
        'codigo': 'CourseEnrolledOk',
        'mensaje': 'Se ha inscrito el curso'
    },
    {
        'codigo': 'CourseUnenrolledOk',
        'mensaje': 'Se ha realizado la desinscripción del curso'
    },
    {
        'codigo': 'SeleccioneCurso',
        'mensaje': 'Debe seleccionar un curso'
    },
    {
        'codigo': 'CursoRetirado',
        'mensaje': 'El curso ha sido retirado'
    },
    {
        'codigo': 'CursoCambiado',
        'mensaje': 'Se ha realizado el cambio de curso'
    },
    {
        'codigo': 'EvaStrExistCode',
        'mensaje': '¡Ya existe un rubro con ese código!'
    },
    {
        'codigo': 'EvaStrReqFormula',
        'mensaje': 'Debe ingresar una fórmula para el cálculo del rubro'
    },
    {
        'codigo': 'EvaStrDeleteFormula',
        'mensaje': 'El rubro pertenece una formula, validar las formulas de los otros rubros'
    },
    {
        'codigo': 'EvaStrValMinimo',
        'mensaje': 'Debe ingresar el valor mínimo'
    },
    {
        'codigo': 'EvaStrValMaximo',
        'mensaje': 'Debe ingresar el valor máximo'
    },
    {
        'codigo': 'EvaStrExistNotaFinal',
        'mensaje': 'Sólo puede existir un rubro de nota final'
    },
    {
        'codigo': 'EvaStrReqNotaFinal',
        'mensaje': 'Debe existir un rubro definido como nota final'
    },
    {
        'codigo': 'EvaStrReqRubros',
        'mensaje': 'Debe ingresar al menos un rubro definido como nota final.'
    },
    {
        'codigo': 'ErrorAcademicOfferIdNotEmty',
        'mensaje': 'No se encontraron los datos de la oferta académica.'
    },
    {
        'codigo': 'ErrorActualizarComentario',
        'mensaje': 'Se presentaron problemas al actualizar el comentario.'
    },
    {
        'codigo': 'ErrorAgregarComentario',
        'mensaje': 'Se presentaron problemas al ingresar el comentario.'
    },
    {
        'codigo': 'ErrorAsignarEstructuraPre',
        'mensaje': 'Se presentaron problemas al asignar la estructura de evaluación.'
    },
    {
        'codigo': 'ErrorComentarioGestion',
        'mensaje': 'Se presentaron problemas al ingresar el comentario.'
    },
    {
        'codigo': 'ErrorCommentNotEmpty',
        'mensaje': 'Debe ingresar el comentario.'
    },
    {
        'codigo': 'ErrorCrearEstructuraEval',
        'mensaje': 'Se presentaron problemas al crear la estructura de evaluación.'
    },
    {
        'codigo': 'ErrorCrearSolGestion',
        'mensaje': 'Se presentaron problemas al crear la solicitud.'
    },
    {
        'codigo': 'ErrorCustomerIdNotEmpty',
        'mensaje': 'No se encontraron los datos del CIF.'
    },
    {
        'codigo': 'ErrorDetalleEstructura',
        'mensaje': 'Se presentaron problemas al obtener el detalle de la estructura de evaluación.'
    },
    {
        'codigo': 'ErrorDetalleGestion',
        'mensaje': 'Se presentaron problemas al obtener el detalle de la solicitud.'
    },
    {
        'codigo': 'ErrorEvaluationStructureIdNotEmpty',
        'mensaje': 'No se encontraron los datos de la estructura de evaluación.'
    },
    {
        'codigo': 'ErrorListadoGestionEstudiante',
        'mensaje': 'Se presentaron problemas al obtener la lista de solicitudes.'
    },
    {
        'codigo': 'ErrorListEstructuras',
        'mensaje': 'Se presentaron problemas al obtener la lista de estructuras de evaluación.'
    },
    {
        'codigo': 'ErrorReqRequestIdNotEmty',
        'mensaje': 'Se presentaron problemas al obtener los datos de solicitud.'
    },
    {
        'codigo': 'ErrorRequestIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos de solicitud.'
    },
    {
        'codigo': 'ErrorResumenGestiones',
        'mensaje': 'Se presentaron problemas al obtener el resumen de las solicitudes.'
    },
    {
        'codigo': 'ErrorTypeNotEmty',
        'mensaje': 'Debe seleccionar el tipo de registro.'
    },
    {
        'codigo': 'ErrorDuplicateRequisitoCurso',
        'mensaje': 'El curso seleccionado ya se encuentra como requisito o correquisito.'
    },
    {
        'codigo': 'ErrorAcademicGradeNotEmpty',
        'mensaje': 'Debe seleccionar el grado académico.'
    },
    {
        'codigo': 'ErrorCourseReqIdNotEmpty',
        'mensaje': 'Debe seleccionar el requisito del curso.'
    },
    {
        'codigo': 'ErrorRequiredCourseIdNotEmpty',
        'mensaje': 'Debe seleccionar el curso requisito/correquisito.'
    },
    {
        'codigo': 'ErrorOriginCourseIdNotEmpty',
        'mensaje': 'Debe seleccionar el curso origen.'
    },
    {
        'codigo': 'ErrorFileFormatIdNotEmpty',
        'mensaje': 'No se encontraron los datos del formato de archivos.'
    },
    {
        'codigo': 'ErrorGradeIdNotEmty',
        'mensaje': 'Debe seleccionar el grado.'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'Formato de archivo (extensión) no permitido.'
    },
    {
        'codigo': 'ErrorValidatingComment',
        'mensaje': 'Debe ingresar un comentario.'
    },
    {
        'codigo': 'ErrorValidatingState',
        'mensaje': 'Debe seleccionar un estado.'
    },
    {
        'codigo': 'CodeRequeridoCredito',
        'mensaje': 'Debe ingresar la cantidad de créditos.'
    },
    {
        'codigo': 'CodeRequeridoBloque',
        'mensaje': 'Debe ingresar el número de bloque.'
    },
    {
        'codigo': 'CodeRequeridoSequencia',
        'mensaje': 'Debe ingresar la secuencia.'
    },
    //CAMPOS OBLIGATORIOS
    {
        'codigo': 'ErrorAddressTypeIdNotEmty',
        'mensaje': 'Debe seleccionar el tipo de dirección.'
    },
    {
        'codigo': 'ErrorCodLanIdNotEmty',
        'mensaje': 'Debe seleccionar el idioma.'
    },
    {
        'codigo': 'ErrorContactNameNotEmty',
        'mensaje': 'Debe ingresar el nombre del contacto.'
    },
    {
        'codigo': 'ErrorContactTypeIdNotEmty',
        'mensaje': 'Debe seleccionar el tipo de teléfono.'
    },
    {
        'codigo': 'ErrorCountryCodeNotEmty',
        'mensaje': 'Debe ingresar el código del país.'
    },
    {
        'codigo': 'ErrorCountryIdNotEmty',
        'mensaje': 'Debe seleccionar el país.'
    },
    {
        'codigo': 'ErrorCourseIdNotEmty',
        'mensaje': 'Debe seleccionar el curso.'
    },
    {
        'codigo': 'ErrorCuaPostalCodeNotEmty',
        'mensaje': 'Debe ingresar el código postal.'
    },
    {
        'codigo': 'ErrorCusBirthDateNotEmty',
        'mensaje': 'Debe ingresar la fecha de nacimiento.'
    },
    {
        'codigo': 'ErrorCusCivilStsNotEmty',
        'mensaje': 'Debe seleccionar el estado civil.'
    },
    {
        'codigo': 'ErrorCusGenderNotEmty',
        'mensaje': 'Debe seleccionar el género.'
    },
    {
        'codigo': 'ErrorCusIdeNotEmty',
        'mensaje': 'Debe ingresar la identificación.'
    },
    {
        'codigo': 'ErrorCusLastName1NotEmty',
        'mensaje': 'Debe ingresar el primer apellido.'
    },
    {
        'codigo': 'ErrorCusLastName2NotEmty',
        'mensaje': 'Debe ingresar el segundo apellido.'
    },
    {
        'codigo': 'ErrorCusNameNotEmty',
        'mensaje': 'Debe ingresar el nombre.'
    },
    {
        'codigo': 'ErrorCusOtherIdeNotEmty',
        'mensaje': 'Debe ingresar el número de CIF.'
    },
    {
        'codigo': 'ErrorCusTypeIdeNotEmty',
        'mensaje': 'Debe seleccionar el tipo de identificación.'
    },
    {
        'codigo': 'ErrorDirectionNotEmty',
        'mensaje': 'Debe ingresar la dirección.'
    },
    {
        'codigo': 'ErrorEmailNotEmty',
        'mensaje': 'Debe ingresar un correo electrónico.'
    },
    {
        'codigo': 'ErrorEmailTypeIdNotEmty',
        'mensaje': 'Debe seleccionar el tipo de correo electrónico.'
    },
    {
        'codigo': 'ErrorJobsIdNotEmty',
        'mensaje': 'Debe seleccionar el puesto de trabajo.'
    },
    {
        'codigo': 'ErrorLanLevelIdNotEmty',
        'mensaje': 'Debe seleccionar un nivel de idioma.'
    },
    {
        'codigo': 'ErrorObservationNotEmty',
        'mensaje': 'Debe ingresar una observación/comentario.'
    },
    {
        'codigo': 'ErrorPhoneNotEmty',
        'mensaje': 'Debe ingresar el número de teléfono.'
    },
    {
        'codigo': 'ErrorProvinceNotEmty',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorStartDateNotEmty',
        'mensaje': 'Debe ingresar la fecha de inicio.'
    },
    {
        'codigo': 'ErrorStateCourseIdNotEmty',
        'mensaje': 'Debe seleccionar un estado del curso.'
    },
    {
        'codigo': 'ErrorTipoCIFNotEmty',
        'mensaje': 'Debe seleccionar un tipo de CIF.'
    },
    {
        'codigo': 'ErrorTypeCourseIdNotEmty',
        'mensaje': 'Debe seleccionar un tipo de curso.'
    },
    {
        'codigo': 'ErrorTypeNacionalidadNotEmty',
        'mensaje': 'Debe seleccionar el tipo de nacionalidad.'
    },
    {
        'codigo': 'ErrorUbication2IdNotEmty',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorUbication3IdNotEmty',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorUbication4IdNotEmty',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorWorkplaceIdNotEmty',
        'mensaje': 'Debe seleccionar el lugar de trabajo.'
    },
    {
        'codigo': 'ProgramRelCourseIdNotEmty',
        'mensaje': 'Debe seleccionar el curso.'
    },
    {
        'codigo': 'InstitutionsOriginIdNotEmty',
        'mensaje': 'Debe seleccionar la institución de origen.'
    },
    {
        'codigo': 'MadeByNotEmty',
        'mensaje': 'Debe ingresar quien aprobó la convalidación.'
    },
    {
        'codigo': 'ScoreNotEmty',
        'mensaje': 'Debe ingresar la nota del estudiante.'
    },
    //FIN CAMPOS OBLIGATORIOS
    {
        'codigo': 'ErrorEventDateNotEmty',
        'mensaje': 'Debe ingresar la fecha del evento.'
    },
    {
        'codigo': 'ErrorTitleNotEmty',
        'mensaje': 'El título es requerido.'
    },
    {
        'codigo': 'ErrorStartTimeNotEmty',
        'mensaje': 'Debe ingresar la hora de inicio.'
    },
    {
        'codigo': 'ErrorEndTimeNotEmty',
        'mensaje': 'Debe ingresar la hora de fin.'
    },
    {
        'codigo': 'ErrorActualizarCeremonia',
        'mensaje': 'Se presentaron problemas al actualizar la ceremonia.'
    },
    {
        'codigo': 'ErrorActualizarCursoConvalidados',
        'mensaje': 'Se presentaron problemas al actualizar el curso a convalidar.'
    },
    {
        'codigo': 'ErrorAdmisionDestinationIdNotEmpty',
        'mensaje': 'Debe seleccionar el programa destino.'
    },
    {
        'codigo': 'ErrorAdmisionOriginIdNotEmpty',
        'mensaje': 'Debe seleccionar el programa de origen.'
    },
    {
        'codigo': 'ErrorCeremonyIdNotEmpty',
        'mensaje': 'No se encontraron los datos de la ceremonia.'
    },
    {
        'codigo': 'ErrorCommentsNotEmpty',
        'mensaje': 'Debe ingresar un comentario.'
    },
    {
        'codigo': 'ErrorCrearCeremonia',
        'mensaje': 'Se presentaron problemas al registrar la ceremonia.'
    },
    {
        'codigo': 'ErrorCrearCursoConvalidados',
        'mensaje': 'Se presentaron problemas al ingresar el curso a convalidar.'
    },
    {
        'codigo': 'ErrorCstIdNotEmpty',
        'mensaje': 'No se encontraron los datos del estudiante dentro de la ceremonia.'
    },
    {
        'codigo': 'ErrorDateAndtimeNotEmpty',
        'mensaje': 'Debe ingresar la fecha y hora.'
    },
    {
        'codigo': 'ErrorEliminarCeremonia',
        'mensaje': 'Se presentaron problemas al eliminar la ceremonia.'
    },
    {
        'codigo': 'ErrorEliminarCursoConvalidados',
        'mensaje': 'Se presentaron problemas al eliminar el curso a convalidar.'
    },
    {
        'codigo': 'ErrorEliminarEstudianteCeremonia',
        'mensaje': 'Se presentaron problemas al eliminar el estudiante de la ceremonia.'
    },
    {
        'codigo': 'ErrorFolioNotEmpty',
        'mensaje': 'El folio es requerido.'
    },
    {
        'codigo': 'ErrorInscribirEstudiantesCeremonia',
        'mensaje': 'Se presentaron problemas al inscribir el estudiante a la ceremonia.'
    },
    {
        'codigo': 'ErrorInstitutionsOriginIdNotEmpty',
        'mensaje': 'La institución de origen es requerida.'
    },
    {
        'codigo': 'ErrorListAcaProgramCourseDetails',
        'mensaje': 'Se presentaron problemas al obtener la lista de cursos del programa.'
    },
    {
        'codigo': 'ErrorListaCeremonia',
        'mensaje': 'Se presentaron problemas al obtener la lista de ceremonias.'
    },
    {
        'codigo': 'ErrorListaCursosConvalidar',
        'mensaje': 'Se presentaron problemas al obtener la lista de cursos para convalidar.'
    },
    {
        'codigo': 'ErrorListaEstudianteCeremonia',
        'mensaje': 'Se presentaron problemas al obtener la lista de estudiantes inscritos en la ceremonia.'
    },
    {
        'codigo': 'ErrorListCoursesHomologate',
        'mensaje': 'Se presentaron problemas al obtener la lista de cursos convalidados.'
    },
    {
        'codigo': 'ErrorMadeByNotEmpty',
        'mensaje': 'Debe ingresar el nombre de la persona responsable.'
    },
    {
        'codigo': 'ErrorObtenerCeremonia',
        'mensaje': 'Se presentaron problemas al obtener los datos de la ceremonia.'
    },
    {
        'codigo': 'ErrorObtenerCursoConvalidado',
        'mensaje': 'Se presentaron problemas al obtener los datos del curso convalidado.'
    },
    {
        'codigo': 'ErrorProgramRelCourseIdNotEmty',
        'mensaje': 'Debe seleccionar un curso.'
    },
    {
        'codigo': 'ErrorRcoIdNotEmpty',
        'mensaje': 'No se encontraron los datos del curso convalidado.'
    },
    {
        'codigo': 'ErrorRecognitionDateNotEmpty',
        'mensaje': 'Debe ingresar la fecha de convalidación.'
    },
    {
        'codigo': 'ErrorScoreNotEmpty',
        'mensaje': 'Debe ingresar una nota.'
    },
    {
        'codigo': 'ErrorSeatNotEmpty',
        'mensaje': 'El asiento es requerido.'
    },
    {
        'codigo': 'ErrorSpaceAvailableNotEmpty',
        'mensaje': 'Debe especificar la cantidad de campos disponibles.'
    },
    {
        'codigo': 'ErrorUpdateHomologateCurses',
        'mensaje': 'Se presentaron problemas al actualizar los datos de la homologación.'
    },
    {
        'codigo': 'ErrorUpdateHomologateCursesStudents',
        'mensaje': 'Se presentaron problemas al homologar los cursos del estudiante.'
    },
    {
        'codigo': 'ErrorValidatingCoursesHomologate',
        'mensaje': 'Se presentaron problemas al validar los datos de la homologación.'
    },
    {
        'codigo': 'ErrorVolumeNotEmpty',
        'mensaje': 'El volumen es requerido.'
    },
    {
        'codigo': 'ErrorValidarConclusion',
        'mensaje': 'Se presentaron problemas al validar la conclusión del programa académico.'
    },
    {
        'codigo': 'ErrorGetInstrPrincipalAcaOffer',
        'mensaje': 'Se presentaron problemas al obtener un profesor principal.'
    },
    {
        'codigo': 'ErrorAcaOffSchedulesReq',
        'mensaje': 'Es requerido ingresar un horario.'
    },
    {
        'codigo': 'ErrorAcaOffClassroomReq',
        'mensaje': 'Es requerido ingresar un aula por cada horario.'
    },
    {
        'codigo': 'ErrorAcaOffInstructorReq',
        'mensaje': 'Es requerido ingresar al menos un profesor por horario.'
    },
    {
        'codigo': 'ErrHomoCourseDuplicate',
        'mensaje': 'El curso esta duplicado.'
    },
    {
        'codigo': 'ErrHomoCourseSameProgram',
        'mensaje': 'El curso no puede pertenecer al mismo programa académico.'
    },
    {
        'codigo': 'ErrInternalPeriodNotFound',
        'mensaje': 'No se encontró un periodo académico para realizar el proceso.'
    },
    {
        'codigo': 'ErrorHomologationStudentCourses',
        'mensaje': 'Se presentaron problemas al realizar el proceso de homologación de cursos.'
    },
    {
        'codigo': 'ErrGradCerAdmissionExists',
        'mensaje': 'El estudiante ya se encuentra inscrito para la ceremonia de graduación con el programa seleccionado.'
    },
    {
        'codigo': 'ErrGradCerExpired',
        'mensaje': 'La ceremonia de graduación ya finalizó.'
    },
    {
        'codigo': 'ErrGradCerFullQuota',
        'mensaje': 'No hay campos disponibles para incluir más estudiantes.'
    },
    {
        'codigo': 'ErrGradCerAddStudent',
        'mensaje': 'Se presentaron problemas al incluir el estudiante a la ceremonia de graduación.'
    },
    {
        'codigo': 'ErrorInsertRecognitionCourse',
        'mensaje': 'Se presentaron problemas al incluir el curso a convalidar.'
    },
    {
        'codigo': 'ErrorUpdateRecognitionCourse',
        'mensaje': 'Se presentaron problemas al actualizar el curso a convalidar.'
    },
    {
        'codigo': 'ErrorDeleteRecognitionCourse',
        'mensaje': 'Se presentaron problemas al eliminar el curso a convalidar.'
    },
    {
        'codigo': 'ErrProgramStudentIncomplete',
        'mensaje': 'El estudiante aún no completa el plan de estudios del programa académico.'
    },
    {
        'codigo': 'ErrRangoHora',
        'mensaje': 'La hora final debe ser mayor a la hora inicial.'
    },
    {
        'codigo': 'ErrorQualifyScoreNotAllowed',
        'mensaje': 'El profesor no tiene permisos para calificar el estudiante.'
    },
    {
        'codigo': 'ErrorRangeQualifyScore',
        'mensaje': 'La calificación ingresada se encuentra fuera del rango permitido.'
    },
    {
        'codigo': 'ErrorGradeStudentItemUpdate',
        'mensaje': 'Se presentaron problemas al actualizar la calificación.'
    },
    {
        'codigo': 'ErrorEnrollAcaOffer',
        'mensaje': 'Se presentaron problemas al inscribir el curso.'
    },
    {
        'codigo': 'ErrorUNEnrollAcaOffer',
        'mensaje': 'Se presentaron problemas al des-inscribir el curso.'
    },
    {
        'codigo': 'ErrorUnRollMandatoryCourse',
        'mensaje': 'Primero debe des-inscribir los cursos no obligatorios.'
    },
    {
        'codigo': 'ErrorMandatoryBlockCourses',
        'mensaje': 'Primero debe inscribir los cursos obligatorios.'
    },
    {
        'codigo': 'ErrorAdmRequirementBlock',
        'mensaje': 'Tiene requisitos pendientes para el ingreso al bloque académico del curso seleccionado.'
    },
    {
        'codigo': 'DuplicateCustomerCountry',
        'mensaje': 'El CIF ya tiene un registro con esa nacionalidad.'
    },
    {
        'codigo': 'ErrorExistsCustomerLanguaje',
        'mensaje': 'Ya existe un registro con este idioma.'
    },
    {
        'codigo': 'CodeRequeridoComentario',
        'mensaje': 'Debe ingresar un comentario.'
    }
];